import { FtlRouteViewModel } from "../../../ViewModel/FtlRouteViewModel";

export const updateOdcsForSpdrAndPdsrOnRoute = (
  route: FtlRouteViewModel,
  odc: string | undefined
) => {
  route.PdsrsOnThisRoute?.forEach((pdsr) => {
    pdsr.ODCs?.push({ OdcGsdb: odc });
  });
  route.SpdrsOnThisRoute?.forEach((spdr) => {
    spdr.ODCs?.push({ OdcGsdb: odc });
  });
};
